import { API_INTERNAL_ENDPOINT } from './constants'
import { type schemaType } from './schema'
import { type paramsType } from './paramsSchema'

export type returnType = ApiServerResponse<schemaType>

export default async (params: paramsType): Promise<returnType> => {
  const { $v2ApiNuxtEndpointPostPlugin } = useNuxtApp()

  const data = await $v2ApiNuxtEndpointPostPlugin(API_INTERNAL_ENDPOINT, params)

  return data as returnType
}
